export default __webpack_public_path__ + "static/selectedfirms-cb7d3dec51d77d37bf922b8ec7b1e599.png";